import { useState } from "react";
import { PageContainer } from "@/layouts/AppLayout";
import { Button, Field } from "@/components/ui";
import { useFeedback } from "@/components/ui/feedback";
import { api, errorMessage } from "@/lib/api";
import { keys, useAction, useMe } from "@/lib/queries";
import { useTheme } from "@/lib/theme";

export function AccountPage() {
  const me = useMe().data!;
  const { toast } = useFeedback();
  const { theme, toggle } = useTheme();
  const [name, setName] = useState(me.name);
  const [pw, setPw] = useState({ currentPassword: "", newPassword: "", confirm: "" });
  const [pwError, setPwError] = useState("");

  const saveName = useAction(() => api.updateMe({ name }), { invalidate: [keys.me, keys.users], onSuccess: () => toast("Name updated", "success") });
  const changePassword = useAction(() => api.changePassword({ currentPassword: pw.currentPassword, newPassword: pw.newPassword }), {
    onSuccess: () => {
      setPw({ currentPassword: "", newPassword: "", confirm: "" });
      setPwError("");
      toast("Password changed. Other sessions were signed out.", "success");
    },
    onError: (err) => setPwError(errorMessage(err)),
  });

  return (
    <PageContainer>
      <h1 className="mb-8 text-3xl font-bold">Account</h1>
      <div className="max-w-md space-y-10">
        <section className="space-y-4">
          <h2 className="font-semibold">Profile</h2>
          <Field label="Email">
            <input value={me.email} readOnly className="field text-muted" />
          </Field>
          <Field label="Display name">
            <input value={name} onChange={(e) => setName(e.target.value)} className="field" dir="auto" />
          </Field>
          <Button variant="primary" onClick={() => saveName.mutate()} loading={saveName.isPending} disabled={!name.trim() || name === me.name}>
            Save
          </Button>
        </section>

        <section className="space-y-4">
          <h2 className="font-semibold">Appearance</h2>
          <div className="flex items-center justify-between rounded-lg border border-line px-3 py-2 text-sm">
            <span>Theme</span>
            <Button size="sm" onClick={toggle}>
              {theme === "dark" ? "Dark" : "Light"} — switch
            </Button>
          </div>
        </section>

        <section>
          <h2 className="mb-4 font-semibold">Change password</h2>
          <form
            className="space-y-4"
            onSubmit={(e) => {
              e.preventDefault();
              if (pw.newPassword !== pw.confirm) return setPwError("The new passwords don't match");
              changePassword.mutate();
            }}
          >
            <Field label="Current password">
              <input type="password" autoComplete="current-password" value={pw.currentPassword} onChange={(e) => setPw({ ...pw, currentPassword: e.target.value })} className="field" />
            </Field>
            <Field label="New password" hint="At least 8 characters">
              <input type="password" autoComplete="new-password" minLength={8} value={pw.newPassword} onChange={(e) => setPw({ ...pw, newPassword: e.target.value })} className="field" />
            </Field>
            <Field label="Confirm new password">
              <input type="password" autoComplete="new-password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} className="field" />
            </Field>
            {pwError && <p className="text-sm text-danger">{pwError}</p>}
            <Button type="submit" variant="primary" loading={changePassword.isPending} disabled={!pw.currentPassword || !pw.newPassword}>
              Change password
            </Button>
          </form>
        </section>
      </div>
    </PageContainer>
  );
}
